<script lang="ts">
	import { run } from 'svelte/legacy';

	import { page } from '$app/stores';

	import { currentEvent } from '$lib/currentEvent';
	import IconCheck from '$lib/icons/IconCheck.svelte';
	import LinkContainer from './LinkContainer.svelte';
	import Modal from '$lib/Modal.svelte';
	import { routes } from '$lib/routes';
	import { replaceState } from '$app/navigation';
	interface Props {
		left?: import('svelte').Snippet;
	}

	let { left }: Props = $props();

	let show = $state(false);

	run(() => {
		if ($page.url.searchParams) {
			show = $page.url.searchParams.get('showEventCreated') === 'true';
		}
	});

	function close() {
		$page.url.searchParams.delete('showEventCreated');
		replaceState($page.url, {});
	}
</script>

{#if show}
	<Modal onclose={close} header={false}>
		<div data-testid="event-created-prompt" class="">
			<div class="mb-4 rounded-md bg-violet-100 p-4 text-violet-900">
				<div class="flex">
					<div class="pl-1 pr-5 pt-2 text-4xl text-violet-800">
						<IconCheck />
					</div>
					<div>
						<b>Event wurde erstellt </b><br />
						Lade deine Gäste mit diesem Link ein.
					</div>
				</div>
			</div>

			<div class="inline-block w-full rounded-md text-gray-900">
				<LinkContainer
					url={$page.url.origin + routes.event($currentEvent.slug)}
					hideOpen
					class="my-4"
					data-testid="public-event-link"
				>
					{#if left}{@render left()}{:else}
						<div class="hidden pl-1 pr-5 pt-3 text-3xl text-violet-600 sm:block">
							<svg
								width="1em"
								height="1em"
								viewBox="0 0 16 16"
								class="bi bi-share"
								fill="currentColor"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									d="M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5zm-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"
								/>
							</svg>
						</div>
					{/if}
				</LinkContainer>
			</div>

			<div>
				Der private Link, zum bearbeiten des Events, wurde dir per E-Mail geschickt.
				<span class="hidden" data-testid="private-event-link">
					{$page.url.origin + routes.editEvent($currentEvent.slug, $currentEvent.ownerSecret ?? '')}
				</span>
			</div>

			<div class="mt-6">
				<button onclick={close} class="btn btn-primary w-full sm:w-auto sm:px-8" data-testid="created-prompt-ok-btn">
					Okay
				</button>
			</div>
		</div>
	</Modal>
{/if}
